import { SectionHeading } from "../components/ui";

export function TermsPage() {
  return (
    <article className="mx-auto max-w-3xl py-6 space-y-6">
      <SectionHeading level={2}>利用規約</SectionHeading>
      <div className="prose prose-sm max-w-none text-tora-ink/80 leading-relaxed">
        <p>
          株式会社えびラーメンとチョコレートモンブランが食べたい（以下「当社」といいます。）は、「令和の虎経営塾利用規約」（以下「本規約」といいます。）を定め、本規約に従い、「令和の虎経営塾」（以下「本サービス」といいます。）を提供します。また、本規約の他、本サービスの利用ガイド、ヘルプ、規約等の記載も、本規約の一部として適用されます。
        </p>

        <h3>第1条（本サービスについて）</h3>
        <ol>
          <li>本サービスは、当社が推奨する講師等による勉強会や交流会、定期的な情報シェア、講師の人脈等を生かした不定期のイベント開催などを、各種SNS又は当社が運営するプラットフォームを通じて、情報を発信する当社と会員、又は会員同士においてコミュニケーションを行うことができる会員制のコミュニケーションサービスです。</li>
          <li>本サービスは、専ら事業者向け（法人及び個人事業主）のサービスであり、申込者ないし会員は事業者でなければ本サービスを受けられません。事業者であるかどうかは申込時に自己申告していただくこととし、サービス提供中に事業者でなくなった場合（法人が解散したり個人事業を廃業したりするなど）には、会員資格が失効しますので直ちにお申し出ください（この場合の返金は本規約第７条の規定によります）。但し、事業者でない場合（サービス提供中に事業者でなくなり、個人として会員継続したい場合を含む）にも、当社が審査の上、任意に申込みないし会員継続を認めた場合には会員資格を得られるものとします。</li>
        </ol>

        <h3>第2条（定義）</h3>
        <p>本規約において、用語の定義は、別途定義されている場合を除き、以下のとおりとします。</p>
        <ol>
          <li>「本サービス」とは、当社が各種SNS又はプラットフォーム及びアプリケーションにおいて開設する、当社と会員、又は会員同士においてコミュニケーションを行うことができる場所をいいます。</li>
          <li>「当社発信情報」とは、当社が本サービスにおいて発信する、文章、画像及び動画等の情報をいいます。</li>
          <li>「申込者」とは、本サービスの入会申込みをする者をいいます。</li>
          <li>「会員」とは、第4条に従って会員登録を行った者をいいます。</li>
          <li>「有効期間」とは、会員が本サービスを利用することができる期間をいいます。</li>
          <li>「各種SNS」とは、Meta Platforms, Inc.（旧Facebook, Inc.）が運営するFacebook等のSNS（ソーシャル・ネットワーキング・サービス）のうち、当社が本サービスの提供媒体として指定するものをいいます。</li>
          <li>「配信コンテンツ」とは、当社発信情報の他に、当社が本サービスにおいて会員に対し配信する文章、画像及び動画等をいいます。なお、配信コンテンツの著作権については、当社に帰属します。</li>
          <li>「会員投稿情報」とは、会員が本サービスに投稿する文章、画像及び動画等を含む一切の情報をいいます。なお、会員投稿情報の著作権その他一切の法的権利については、会員投稿情報を投稿した会員又は当該会員に利用を許諾した第三者に帰属します。</li>
          <li>「会員プラットフォーム」（Meta Platforms, Inc、コミューン、その他）当社が本サービスの提供媒体として指定するものをいいます。</li>
        </ol>

        <h3>第3条（会員資格）</h3>
        <p>本サービスを利用するには、会員になる必要があり、会員になるには、以下の要件を全て満たすことによって会員の資格が付与されます。</p>
        <ol>
          <li>当社が行う審査に合格すること</li>
          <li>本規約に同意すること</li>
          <li>本来的に専ら事業者向けのサービスであるため、非事業者として会員となる場合にも本規約の適用など事業者と同様の取扱になることにつき予め同意すること</li>
          <li>会員となる者が未成年者の場合、法定代理人の同意を得ること</li>
        </ol>

        <h3>第4条（会員登録）</h3>
        <ol>
          <li>申込者は当社に対し、当社が定める方法により本サービスの入会申込みを行うものとします。</li>
          <li>本サービスの会員登録（以下「会員登録」といいう）は、申込者が利用料金を支払った時点、又は配信コンテンツの購入の申込みを行った時点のいずれか早い時点で完了します。</li>
          <li>当社は、申込者からの入会申込みに際し、所定の審査を行う場合があります。この場合、前項の規定は適用されず、申込者が利用料金を支払った時点で会員登録が完了します。</li>
          <li>申込者は、当社が申込者からの入会申込みについて、承諾しない場合があることを予め同意するものとします。なお、当社は申込者に対し、不承諾の理由を説明する義務を負わないものとします。</li>
        </ol>

        <h3>第5条（配信コンテンツ利用について）</h3>
        <ol>
          <li>会員は、当社が特に認めた場合、配信コンテンツを無料で利用できます。</li>
          <li>会員は、配信コンテンツを当社が定める利用環境等で利用することができます。</li>
          <li>会員が本サービスの自主退会、又は会員資格が失効した場合、当該会員は全てのコンテンツを利用することができなくなります。</li>
          <li>当社は、配信コンテンツの配信を自己の判断で停止又は終了する場合があります。この場合、配信コンテンツについて、第7条第1項の定めが適用されます。</li>
        </ol>

        <h3>第6条（利用料金、利用期間等）</h3>
        <ol>
          <li>本サービスを利用するには、本条第5項に定める方法により、当社に対して、利用料金及び入会金（以下「入会金」といいます。）を前払いで支払う必要があります。</li>
          <li>入会金は110,000円（税込）、利用料金は33,000円（税込）、有効期間は1ヶ月間とします。なお、本サービス中「交流会」については、この利用料金とは別途費用が必要です。その他、この利用料金とは別途費用が必要なサービスについてはサービス提供前に告知します。</li>
          <li>会員は、入会金及び利用料金を支払うことにより、有効期間中、本サービスを利用することができます。</li>
          <li>会員登録は、会員が、有効期間までに自主退会、又は会員資格が失効しない限り、原則自動的に更新（以下「自動更新」といいます。）されるものとします。前項により自動更新される場合、利用料金は、有効期間が経過した時（以下「更新時」といいます。）に、会員が会員登録の際に指定した支払方法により自動的に決済されるものとします。</li>
          <li>利用料金の支払い方法は、クレジットカードに限るものとします。当社は、利用料金を変更する場合、やむを得ない場合を除き、変更日の1か月前までに会員に告知するものとします。</li>
          <li>最低利用期間は12ヶ月とし、途中キャンセルされた場合にも最低利用期間分までの未納分は全額お支払いいただきます。最低利用期間経過後は、自主退会を認めます（ただし1ヶ月未満の日割り精算による返金は行いません）。</li>
          <li>会員が利用料金を未入金のまま２週間経過した場合には、当社は本サービスの利用を停止することができる。</li>
          <li>会員が利用料金を２ヶ月分未納の場合には、当社は会員に何ら通知催告することなしに本契約を解除することができる。</li>
        </ol>

        <h3>第7条（返金等）</h3>
        <ol>
          <li>当社は、会員が支払った入会金及び利用料金について、理由の如何を問わず返金を行わないものとします。</li>
          <li>会員が本サービスを有効期間内に自主退会、又は会員資格が失効した場合であっても、前項と同様とします。</li>
          <li>会員が、第６条７項に定める最低利用期間内に退会等した場合には、残期間に応じた未払い分の利用料金の支払いを要します（例えば、会員が6ヶ月利用で退会等した場合には、残りの6ヶ月分の利用料金の支払いを要します。）。</li>
        </ol>

        <h3>第8条（禁止事項等）</h3>
        <ol>
          <li>当社は、会員による本サービスの利用に際して、本規約に別途定める事項及び規約等に記載する事項の他、以下の行為を禁止します。なお、以下の各号に定める禁止事項は、会員投稿情報にも適用されるものとします。
            <ol>
              <li>援助交際・売春・買春等を勧誘・誘発・助長する行為、又は隠語全般含め曖昧な表現をして、それらを勧誘・誘発・助長するような投稿行為、出会いや交際等を目的とする行為</li>
              <li>児童ポルノの頒布又は児童虐待を誘引するおそれのある行為</li>
              <li>他の会員、当社又は第三者の著作権、商標権、特許権、実用新案権、プライバシー権、肖像権、パブリシティ権その他の権利を侵害する行為、又は侵害するおそれのある行為</li>
              <li>SNSまたは動画配信サイトなどで、他の会員、当社又は第三者を誹謗中傷し、又は名誉もしくは信用を傷つける行為</li>
              <li>差別に繋がる民族、宗教、人種、性別又は年齢等に関する表現行為、自殺、集団自殺、自傷、違法薬物使用又は脱法薬物使用等を勧誘・誘発・助長するような行為</li>
              <li>会員資格の売買、その他類似行為</li>
              <li>当社の許諾を得ずに自己又は第三者の商品やサービスの広告・宣伝・誘導を目的とする行為、又はその他スパムメール・チェーンメール等の勧誘を目的とする行為</li>
              <li>他の会員、当社又は第三者に不利益を与える行為</li>
              <li>公序良俗、その他法令に違反する行為又は犯罪に結びつく行為及び当該行為を勧誘・幇助・強制・助長する行為</li>
              <li>当社の事前の承諾なく、本サービスにより得た情報を転載又は引用及び他メディアへの掲載等をする行為</li>
              <li>反社会的勢力に利益を提供し、又は便宜を供与する行為</li>
              <li>他の会員の情報収集目的、宗教や政治活動への勧誘目的で本サービスを利用する行為</li>
              <li>事実に反する情報を他の会員に流布する行為</li>
              <li>他の会員による本サービスの利用を妨害する行為</li>
              <li>他の会員又は第三者になりすまして、本サービスを利用する行為</li>
              <li>各種SNSの定める規約等に反する行為</li>
              <li>配信コンテンツの著作権、商標権等の知的財産権その他の権利を侵害し、又は侵害するおそれのある行為</li>
              <li>配信コンテンツに施された技術的保護手段を回避する行為</li>
              <li>本サービスを通じて取得した個人情報を本人の同意なく第三者に提供する行為</li>
              <li>本サービスにより提供される情報を改ざん・消去する行為</li>
              <li>当社のサーバーに過度の負担を及ぼす行為</li>
              <li>本サービスに接続されている他のコンピューター・システム又はネットワークへの不正アクセスを試みる行為</li>
              <li>コンピューターウィルス等有害なプログラムを使用し、もしくは提供する行為、又はこれらの行為を推奨する行為</li>
              <li>本サービス又は本サービス上で使用されているソフトウエアをリバース・エンジニアリング、逆コンパイル、又は逆アセンブルする行為</li>
              <li>本サービスの他、当社の運営するサービスを妨害する行為</li>
              <li>前各号に定める行為を助長する行為</li>
              <li>前各号に定める行為と疑われる行為</li>
              <li>その他、当社が不適切と判断した行為</li>
            </ol>
          </li>
          <li>前項各号の禁止事項に該当するか否かについては、当社の裁量により判断することができるものとします。</li>
          <li>会員は、本サービス（本契約）継続中及び終了後といえども、本サービスに関して知り得た当社に関する一切の情報の口外を禁止します。</li>
        </ol>

        <h3>第9条（自主退会）</h3>
        <ol>
          <li>会員は、最低利用期間12ヶ月経過後には本サービスの退会フォームでの手続きを行うことで、本サービスを退会することができるものとします。ただし、この場合、第7条の規定が適用されるものとし、退会した場合といえども最低利用期間に満つるまでの利用料金の支払いを要します。</li>
          <li>会員が本サービスを退会した場合においても、当該会員による会員投稿情報については、他の会員において無償で閲覧可能な状態となることを予め了承するものとします。</li>
          <li>本サービス退会後の配信コンテンツの利用に関しては、第5条第3項及び第4項の規定をご確認ください。</li>
        </ol>

        <h3>第10条（会員資格の失効）</h3>
        <ol>
          <li>会員において、以下の事由が生じた場合、会員資格は失効するものとし、当該会員は本サービスの全部又は一部が利用できなくなります。
            <ol>
              <li>更新時において、会員が登録したクレジットカードによる未決済にて会員登録の自動更新ができない場合</li>
              <li>第11条に定める場合</li>
              <li>第6条に定める場合</li>
            </ol>
          </li>
          <li>会員資格が失効した場合には、会員は本サービスに再入会することはできないものとする。</li>
        </ol>

        <h3>第11条（規約違反行為等に対する措置）</h3>
        <p>当社は、本サービスを適正に運営するため、会員が以下に定める事項に該当する場合には、あらかじめ会員に通知することなく、会員投稿情報の削除、本サービスの利用停止、会員資格の失効等、必要な措置を講じることができるものとします。</p>
        <ol>
          <li>会員が本規約に定められている事項もしくは当社規約等に記載する事項に違反した場合、又はそのおそれがあると当社が判断した場合</li>
          <li>会員と当社との間の信頼関係が失われた場合もしくは、当社が会員による本サービスの利用を不適当であると判断した場合</li>
          <li>会員が、法令ないし公序良俗に反する投稿や行動をしたと当社が判断する場合</li>
        </ol>

        <h3>第12条（会員のデータ及び会員投稿情報等の取扱い）</h3>
        <ol>
          <li>当社は、本サービスの保守や改良等の必要が生じた場合には、会員投稿情報につき、サービスの保守や改良等に必要な範囲で無償で自由に複製等を行えるものとします。</li>
          <li>当社は、本サービスの広告及び本サービスにより派生する商品化の目的のために、会員投稿情報を無償で利用できるものとし、会員は、これを当社に対して、永続的かつ取消不能のものとして許諾するものとします。ただし、個人を特定することのできる情報や会員が限定公開の意図をもって投稿した情報を利用する場合、当社は、当該情報を投稿した会員の事前の承諾を得るものとします。</li>
          <li>会員は、前項による会員投稿情報の利用について、当社に対し著作者人格権を行使しないものとします。</li>
        </ol>

        <h3>第13条（オンラインコンテンツの取扱い）</h3>
        <ol>
          <li>当社は、本サービスの録画・録音・撮影等（以下「録画等」といいます。）をすることがあります。この録画等は、オンラインコンテンツとして会員に提供したり本サービスの広告に利用したりする目的とし、会員はこれを予め了承します。</li>
          <li>当社は、本サービスの録画等（アーカイブ）を会員に提供しない場合があります。その可否および範囲は、専ら当社の判断により決定できるものとします。受講者による無断での本サービスの録画等やスクリーンショット等での記録行為を禁止します。</li>
        </ol>

        <h3>第14条（会員投稿情報）</h3>
        <ol>
          <li>当社は、会員に本サービスを快適にご利用いただくため、当社自ら又は第三者に委託し、24時間365日、担当者の目視又は自動監視システムにより、会員投稿情報を監視しています。ただし、当社は監視義務を負うものではありません。</li>
          <li>会員は、会員投稿情報に関する著作権等を放棄し（当社に帰属）、著作者人格権は行使しないことを予め了解します。</li>
        </ol>

        <h3>第15条（本サービスの停止、変更、終了）</h3>
        <ol>
          <li>当社は、以下のいずれかに該当する場合、本サービスの全部又は一部の提供をいつでも停止することができるものとします。
            <ol>
              <li>本サービスに係るシステムの点検又は保守作業等を行う場合</li>
              <li>システム、通信回線等が停止した場合</li>
              <li>地震、落雷、火災、風水害、停電等の天災事変その他非常事態の発生した場合</li>
              <li>各種SNSのサービスが停止した場合</li>
              <li>その他、当社が本サービスを停止することが必要であると判断した場合</li>
            </ol>
          </li>
          <li>当社は、当社の都合により、本サービスの内容を変更し、又は本サービスの提供を終了することができるものとします。</li>
          <li>当社は、本サービスの停止等によって会員が被った損害を賠償する責任を負わないものとします。</li>
        </ol>

        <h3>第16条（免責事項）</h3>
        <ol>
          <li>当社は、以下に掲げる事項について、一切保証しないものとします。
            <ol>
              <li>本サービスで提供される全ての情報に関する、有用性、適合性、完全性、正確性、信頼性、安全性、合法性、道徳性、最新性</li>
              <li>各種SNS上に掲載されている事項</li>
              <li>本サービスの提供に不具合、エラーや障害が生じないこと</li>
              <li>当社発信情報及び配信コンテンツが第三者の権利を侵害しないこと</li>
              <li>本サービスの存続又は同一性が維持されること</li>
            </ol>
          </li>
          <li>会員は、当社又は他の会員との間で紛争が生じた場合には、当事者間においてこれを解決するものとします。</li>
          <li>当社の債務不履行又は不法行為に基づき会員に損害が発生した場合、当社は当該月の利用料金の額を上限として損害賠償責任を負います。ただし、当社に故意又は重過失がある場合はこの限りではありません。</li>
        </ol>

        <h3>第17条（損害賠償）</h3>
        <p>会員の行為に起因して当社に損害が発生した場合、当社は会員に対し、当該損害の全額（弁護士費用等を含みます。）を賠償請求できるものとします。</p>

        <h3>第18条（個人情報の取扱い）</h3>
        <ol>
          <li>当社は、申込者及び会員が提供する個人情報を、当社の「個人情報保護に関して」の規定に則り取扱うものとします。</li>
          <li>当社は、個人情報を、本サービスの提供及び入会審査に関する手続に利用することができるものとします。</li>
          <li>申込者及び会員は、当社が個人情報のうち前項に定める目的に必要な範囲の情報を第三者に対し提供することに同意するものとします。</li>
        </ol>

        <h3>第19条（規約の変更）</h3>
        <ol>
          <li>当社は、必要と判断した場合、本規約を民法第548条の4の規定に基づき変更することがあります。</li>
          <li>変更を行う場合は、通知を最初に発信した日から起算して15日の予告期間をおくものとします。</li>
          <li>利用者は、変更に異議がある場合には、予告期間中に解約を通知することができます。この場合も本規約第7条が適用されます。</li>
        </ol>

        <h3>第20条（当社からの通知）</h3>
        <ol>
          <li>当社から会員への連絡事項については、登録したメールアドレス又は各種SNS又は登録した住所宛に連絡又は通知を行います。</li>
          <li>変更がある場合、直ちに変更手続きをするものとします。</li>
          <li>変更手続きを怠ったことにより生じた損害等について、当社は何らの責任を負わないものとします。</li>
        </ol>

        <h3>第21条（権利義務の譲渡禁止）</h3>
        <p>会員は、本規約に基づく全ての契約について、その契約上の地位及びこれにより生じる権利義務の全部又は一部を、当社の書面による事前の承諾なく第三者に対し譲渡、移転、担保設定その他の処分をすることはできないものとします。</p>

        <h3>第22条（準拠法、裁判所）</h3>
        <ol>
          <li>本規約は、日本法に準拠して解釈されるものとします。</li>
          <li>当社、申込者及び会員は、本規約に関し生じた紛争の解決について、東京地方裁判所を第一審の専属的合意管轄裁判所とすることをあらかじめ合意するものとします。</li>
        </ol>

        <p className="text-tora-ink/50 mt-8">（附則）2026年5月18日</p>
      </div>
    </article>
  );
}
